import { TooltipProps } from 'recharts'
import { DateTime } from 'luxon'

import { Card, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'

export const MonthToDateIncomeCardCustomTooltip = ({
  active,
  payload,
  pastValue,
}: TooltipProps<number, string> & { pastValue: 'month' | 'year' }) => {
  if (!active || !payload) {
    return null
  }

  const today = DateTime.now()

  const current = payload.find((item) => item.dataKey === 'current')
  const past = payload.find((item) => item.dataKey === 'past')

  if (!current || !past) {
    return null
  }

  return (
    <Card>
      <Text variant={TypographyStyles.LABEL_SM} className="mb-2">
        <b>
          {pastValue === 'month'
            ? `Day ${current.payload.dayOfMonth}`
            : `${today.toFormat(DATE_FORMATS_LUXON.MONTH)} ${current.payload.dayOfMonth}`}
        </b>
      </Text>
      <Text variant={TypographyStyles.BODY_XS} className="mb-1">
        {pastValue === 'month'
          ? today.toFormat(DATE_FORMATS_LUXON.MONTH)
          : today.toFormat('yyyy')}
        : {formatCurrencyFromCents(current.value, { hideDecimalsIfZero: true })}
      </Text>
      <Text variant={TypographyStyles.BODY_XS}>
        {pastValue === 'month'
          ? today.minus({ month: 1 }).toFormat(DATE_FORMATS_LUXON.MONTH)
          : today.minus({ year: 1 }).toFormat('yyyy')}
        : {formatCurrencyFromCents(past.value, { hideDecimalsIfZero: true })}
      </Text>
    </Card>
  )
}
